export const GET_SESSIONS_ADMIN = 'admin/get_sessions'
export const UPDATE_SESSIONS_ADMIN = 'admin/update_sessions'
export const DELETE_SESSION_ADMIN = 'admin/delete_session'
export const CREATE_PATIENT = 'admin/create_patient'
export const UPDATE_PATIENT = 'admin/update_patient'
export const BOOK_BY_ADMIN = 'admin/booking'
export const GET_RESULTS = 'admin/get_results'
